import React, { type FunctionComponent } from 'react'
import { TextButton } from '@retailer-platform/shared-components'
import { useDomainMessage } from 'domains/collections/utils/domain/intl'
import {
  type CollectionDatum,
  type CollectionsRoutingConfig,
} from 'domains/collections/types/collections.types'
import { canCurrentRetailerModifyCollection } from 'domains/collections/utils/collections.utils'
import { useDomainGoToPath } from 'domains/collections/utils/domain/routing'

interface Props {
  collection: CollectionDatum
  routingConfig: CollectionsRoutingConfig
  retailerId: string
}

export const CollectionsListEditCell: FunctionComponent<Props> = ({
  collection,
  routingConfig,
  retailerId,
}) => {
  const goToEdit = useDomainGoToPath(routingConfig.edit, {
    collectionId: collection.id,
  })

  const editMessage = useDomainMessage('collectionsDomain.list.content.edit')

  if (collection.canEdit && canCurrentRetailerModifyCollection(collection, retailerId)) {
    return <TextButton onClick={goToEdit}>{editMessage}</TextButton>
  }

  return null
}
